import { Logger } from "../../Logger";
import { ErrorContext } from "gather-common/dist/src/public/utils";
export default class AwaitingSFUCallbacks {
    clear() {
        this._addrToCallbacks = {};
        this._idToAddr = {};
    }
    isAwaitingSFU(sfuAddr) {
        return sfuAddr in this._addrToCallbacks;
    }
    playerToSFUAddr(id) {
        return this._idToAddr[id];
    }
    hasCallbacks(sfuAddr) {
        const callbacks = this._addrToCallbacks[sfuAddr] ?? [];
        return callbacks.length > 0;
    }
    addCallback(sfuAddr, id, callback, resolve, reject) {
        this.deleteCallbackOfPlayer(id);
        const callbacks = this._addrToCallbacks[sfuAddr] ?? [];
        callbacks.push({ id, callback, resolve, reject });
        this._addrToCallbacks[sfuAddr] = callbacks;
        this._idToAddr[id] = sfuAddr;
    }
    deleteCallbackOfPlayer(id) {
        const sfuAddr = this._idToAddr[id];
        if (!sfuAddr)
            return;
        delete this._idToAddr[id];
        const callbacks = this._addrToCallbacks[sfuAddr];
        if (!callbacks) {
            Logger.error("addrToCallbacks does not contain ", new ErrorContext({ sfuAddr }));
            return;
        }
        const filteredCallbacks = callbacks.filter((callback) => {
            if (callback.id === id && callback.reject !== undefined) {
                callback.reject();
            }
            return callback.id !== id;
        });
        this._addrToCallbacks[sfuAddr] = filteredCallbacks;
    }
    doneAwaiting(sfuAddr) {
        this._addrToCallbacks[sfuAddr]?.forEach(({ id, callback, resolve }) => {
            callback();
            if (resolve) {
                resolve();
            }
            delete this._idToAddr[id];
        });
        delete this._addrToCallbacks[sfuAddr];
    }
    cancelAwaiting(sfuAddr) {
        this._addrToCallbacks[sfuAddr]?.forEach(({ id, reject }) => {
            if (reject) {
                reject();
            }
            delete this._idToAddr[id];
        });
        delete this._addrToCallbacks[sfuAddr];
    }
    summarize() {
        const addrToCallbacks = {};
        Object.entries(this._addrToCallbacks).forEach(([sfuAddr, callbacks]) => {
            addrToCallbacks[sfuAddr] = callbacks.map((entry) => entry.id);
        });
        return addrToCallbacks;
    }
    _addrToCallbacks = {};
    _idToAddr = {};
}
//# sourceMappingURL=AwaitingSFUCallbacks.js.map